import styled from "@emotion/styled";
import { css } from "@emotion/react";

export const ForestWrapper = styled.div<{ customBackgroundUrl?: string }>`
  position: relative;

  &::before {
    background-image: url(/images/app/mountains-background.svg);
    background-repeat: repeat-x;
    background-size: 1000px;
    background-position: top;
    height: 100%;
    left: 0;
    content: "";
    position: absolute;
    top: -170px;
    width: 100%;

    @media ${(props) => props.theme.bp.mobileUp} {
      background-size: 1600px;
    }

    ${(props) =>
      props.customBackgroundUrl &&
      css`
        background-image: url(${props.customBackgroundUrl});
        // iOS Safari SVG rendering is weird, have a 2px overhang to prevent thin white line
        top: -208px;

        @media ${props.theme.bp.tabletUp} {
          top: -240px;
        }
      `}
  }
`;

export const Wrapper = styled.section<{ isForestHidden?: boolean }>`
  background-color: rgb(8, 96, 71);
  color: ${(props) => props.theme.colors.snowdrop};
  min-height: ${(props) => (props.isForestHidden ? "172px" : "400px")};
  overflow: hidden;
  padding: ${(props) => (props.isForestHidden ? "48px 0 0" : "48px 0 80px")};
  text-align: center;

  @media ${(props) => props.theme.bp.mobileUp} {
    min-height: ${(props) => (props.isForestHidden ? "280px" : "400px")};
  }

  div {
    outline: 0;
  }
`;

export const Tuft = styled.div`
  padding: 50px;
  background-image: url("./grass_tuft.png");
  position: absolute;
`;
